var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('case-build-assistant-container',{attrs:{"id":_vm.caseId},on:{"added":function (id) { return _vm.onCaseAdded(id); },"close":_vm.onCaseClosed,"onSaveStart":_vm.onSaveStart,"onSaveEnd":_vm.onSaveEnd}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }